
const EditIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <g clip-path="url(#clip0_133_1936)">
                <path d="M15.8805 5.10904C16.277 4.71261 16.4998 4.17489 16.4999 3.61418C16.4999 3.05347 16.2773 2.5157 15.8808 2.11917C15.4844 1.72263 14.9467 1.49983 14.386 1.49976C13.8253 1.49969 13.2875 1.72236 12.891 2.11879L2.88145 12.1305C2.70732 12.3042 2.57854 12.5179 2.50645 12.753L1.5157 16.017C1.49632 16.0819 1.49485 16.1508 1.51146 16.2164C1.52807 16.2821 1.56214 16.342 1.61005 16.3898C1.65796 16.4376 1.71792 16.4716 1.78357 16.4881C1.84922 16.5046 1.91812 16.503 1.98295 16.4835L5.2477 15.4935C5.48258 15.4221 5.69633 15.2941 5.8702 15.1208L15.8805 5.10904Z" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M11.25 3.75L14.25 6.75" stroke="#667085" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_133_1936">
                    <rect width="18" height="18" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default EditIcon
